import { motion } from "framer-motion";

/**
 * Reveal — gentle scroll-triggered fade/rise for sections.
 * Respects prefers-reduced-motion automatically via framer-motion.
 */
export const Reveal = ({ children, delay = 0, y = 24, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

/**
 * MaskedLines — kinetic line-by-line headline reveal.
 * Pass an array of strings; each renders on its own masked line.
 */
export const MaskedLines = ({ lines = [], className = "", stagger = 0.12, delay = 0.1 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span className="line-mask" key={i}>
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * stagger, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
